export const API_URL = {
  account: {
    root: 'account',
    login: 'authenticate',
    refreshAccessToken: 'token/refresh',
    forgotPassword: {
      root: 'reset-password',
      init: 'init',
      finish: 'finish',
    },
    changePassword: 'change-password',
  },
  users: {
    root: '',
    allCustomers: 'customer/all',
    paginatedList: 'customer',
    sflEmployees: 'sfl-users',
    details: 'customer',
    addCustomer: 'customer',
    companySize: 'company-size',
    vertical: 'vertical',
    stakeholder: 'stakeholder',
    paginatedFilterList: 'customer/filter',
    deliveryManagerList: 'users/roles/',
  },
  projects: {
    root: '',
    paginatedProjectList: 'project',
    action: 'sfl-users',
    teamAllocation: 'team-allocation',
    projectLink: 'project-link',
    projectNote: 'project-notes',
    paginatedFilterList: 'project/filter',
    projectStage: 'project-stages',
    projectReport: 'project-report',
    projectStatus: 'project-status',
    projectInvoice: 'invoicing',
    roles: 'roles',
  },
  firebaseSubscription: {
    subscribe: 'subscribe',
    unsubscribe: '',
  },
  linkPreview: {
    apiURL: 'https://api.linkpreview.net',
    apiHeader: 'X-Linkpreview-Api-Key',
    apiHeaderKey: 'd3e4b7dddba1dfd87d2f3c7aa4f79fc6',
  },
  acitivity: {
    activityAPI: 'management/audits/entity/',
  },
};
